import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import {
  componentDestroyed,
  League,
  Tournament,
  TournamentSeason,
  TournamentStatuses, TournamentTypes,
  UntilDestroy
} from '@mtgame/core';
import { takeUntil } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';
import { LeagueRootService } from '@core/services/league-root.service';
import { LeagueTournamentsService } from '@core/services/league-tournaments.service';
import { GALO_TOURNAMENT_IDS } from '@utils/hardcode';
import { UntypedFormControl } from '@angular/forms';

@UntilDestroy
@Component({
  selector: 'mtg-league-tournaments',
  templateUrl: './league-tournaments.component.html',
  styleUrls: ['./league-tournaments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueTournamentsComponent implements OnInit, OnDestroy {
  seasons: TournamentSeason[] = [];
  league: League;
  tournamentsBySeason: {[key: number]: Tournament[]};
  tournamentStatuses = TournamentStatuses;
  tournamentTypes = TournamentTypes;
  seasonControl = new UntypedFormControl();
  searchControl = new UntypedFormControl();

  constructor(
    private seoService: SeoService,
    private leagueRootService: LeagueRootService,
    private leagueTournamentsService: LeagueTournamentsService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.seoService.setData({title: 'Турниры'});
    this.leagueRootService.league$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(league => {
        this.league = league;
        this.cdr.markForCheck();
      });
    this.leagueTournamentsService.seasons$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(seasons => {
        this.seasons = seasons;
        this.cdr.markForCheck();
      });

    this.leagueTournamentsService.tournaments$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(tournaments => {
        this.tournamentsBySeason = tournaments
          .filter(item => !item.seasonTournamentId || item.status === TournamentStatuses.closed)
          .sort((a, b) => {
            if (a.status !== b.status) {
              return a.status - b.status;
            }
            return a.sort - b.sort;
          })
          .reduce((acc, item) => ({
            ...acc,
            [item.season.id]: [
              ...(acc[item.season.id] || []),
              item
            ]
          }), {});
        this.cdr.markForCheck();
      });
    this.seasonControl.valueChanges.subscribe(seasonId => {
      this.leagueTournamentsService.setSeasonId(seasonId);
    });
    this.searchControl.valueChanges
      .subscribe(query => {
        this.leagueTournamentsService.setSearch(query);
      });
  }

  ngOnDestroy(): void {
    this.seoService.reset();
    this.leagueTournamentsService.dispose();
  }

  isGaloTournament(tournamentId: number): boolean {
    return GALO_TOURNAMENT_IDS.includes(tournamentId);
  }
}
